var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg067Filter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,0.103H20c-11.046,0-20,8.954-20,20c0,77.49,22.928,145.332,72.155,213.502 c30.712,42.531,85.808,73.844,113.845,87.866v121.426c0,7.633,4.346,14.601,11.2,17.96l100,49c2.784,1.364,5.795,2.04,8.799,2.04 c3.684,0,7.357-1.017,10.584-3.029C322.44,505.215,326,498.8,326,491.897v-82.425c0-11.046-8.954-20-20-20 c-11.046,0-20,8.954-20,20v50.353l-60-29.4V308.897c0-7.813-4.55-14.911-11.65-18.173 c-37.338-17.156-85.782-47.322-109.766-80.536C64.849,155.163,44.258,100.64,40.597,40.103h430.806 c-3.661,60.536-24.252,115.06-63.987,170.085c-25.348,35.103-73.046,65.879-109.072,80.807 c-10.204,4.229-15.049,15.928-10.82,26.133c4.228,10.204,15.927,15.049,26.133,10.82c38.221-15.838,94.204-50.049,126.188-94.343 C489.072,165.435,512,97.593,512,20.103C512,9.057,503.046,0.103,492,0.103z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg067Filter);
export default __webpack_public_path__ + "static/media/067-filter.a1dc779e146346669d00ed65043bf5d8.svg";
export { ForwardRef as ReactComponent };